export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-500-59a26cdb73eb203025db9ae0f3278a26.eot";